export default function dispatchNavigationAdBannerRendered() {
  const navigationAdBannerRendered = new CustomEvent('navigationAdBannerRendered');
  window.dispatchEvent(navigationAdBannerRendered);
}
